<template>
  <div
    class="flex items-center justify-center space-x-4 bg-neutral-600 py-3 text-xs font-medium text-white"
  >
    <div>Your account is not active yet.</div>
    <InertiaLink
      :href="firstItemToComplete.href"
      class="inline-flex items-center"
      test_id="profile-incomplete-status-bar"
    >
      ({{ progressInPercent }}%) {{ firstItemToComplete.description }}
      <ChevronRightIcon class="ml-1 h-4 w-4" />
    </InertiaLink>
  </div>
</template>

<script setup>
import { useUserProfileCompletion } from '@/shared/composables/useUserProfileCompletion.js'
import ChevronRightIcon from '~icons/lucide/chevron-right'

const { progressInPercent, firstItemToComplete } = useUserProfileCompletion()
</script>
